import { render, staticRenderFns } from "./CreateProductsBlock.vue?vue&type=template&id=3d974e98&scoped=true"
import script from "./CreateProductsBlock.vue?vue&type=script&lang=js"
export * from "./CreateProductsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d974e98",
  null
  
)

export default component.exports